import styled from 'styled-components';
import { IRadioLabelProps, IRadioButtonProps } from 'src/components/Input/RadioInput/RadioInput.i';

// hidden input that is still accessible
export const RadioInput = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: fixed;
  white-space: nowrap;
  width: 1px;
`;

export const RadioOptionLabel = styled.label<IRadioLabelProps>`
  color: ${(props) => (props.disabled ? props.theme.black[40] : props.theme.black[10])};
  font-family: ${(props) => props.theme.sansSerif};
  font-size: 1.8rem;
  line-height: 1.5;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  margin-bottom: 10px;
`;

// Styled radio button/option circle. Filled when checked
export const RadioButton = styled.span<IRadioButtonProps>`
  display: block;
  width: 1em;
  height: 1em;
  line-height: 1.5;
  border-radius: 50%;
  border: 0.15em solid ${(props) => (props.disabled ? props.theme.black[40] : props.theme.black[10])};
  background: ${(props) => (props.checked ? props.theme.black[0] : '')};
  ${RadioInput}:focus + & {
    ${(props) => props.theme.focusBoxShadow};
  }
  margin-right: 5px;
  transform: translateY(0.2em);
  flex-shrink: 0;
`;
